import OFFICE_MAIN_DATA from "./office_main";
import OFFICE_MONITOR_DATA from "./office_monitor";
import OFFICE_TV_DATA from "./office_tv";

const data = [OFFICE_MAIN_DATA, OFFICE_TV_DATA, OFFICE_MONITOR_DATA];
export default data;
